import React, { useEffect, useState } from "react";
import "./EditRoleModal.css";
import { getSidebarAPI } from "../../../utils/APIs/sidebar";
import { UpdateRoleAPI } from "../../../utils/APIs/RoleApis";
import { toast } from "react-toastify";
import Loader from "../../../Loader/Loader";

const EditRoleModal = ({ isOpen, onClose, role, onUpdated }) => {
  const [roleName, setRoleName] = useState("");
  const [description, setDescription] = useState("");
  const [sidebarItems, setSidebarItems] = useState([]);
  const [permissions, setPermissions] = useState({});
  const [loading, setLoading] = useState(false);

  // ✅ Fetch sidebar once when modal opens
  useEffect(() => {
    if (!isOpen) return;

    const fetchSidebar = async () => {
      try {
        const res = await getSidebarAPI();
        const items = res?.data?.data || [];
        setSidebarItems(items);
      } catch (err) {
        console.error("Sidebar fetch failed", err);
      }
    };

    fetchSidebar();
  }, [isOpen]);

  // ✅ Prefill when role or sidebar loads
  useEffect(() => {
    if (!role || sidebarItems.length === 0) return;

    setRoleName(role.roleName || "");
    setDescription(role.description || "");

    const updatedPermissions = {};
    sidebarItems.forEach((item) => {
      updatedPermissions[item.name] =
        role?.permissions?.includes(item.name) || false;
    });

    setPermissions(updatedPermissions);
  }, [role, sidebarItems]);

  // ✅ Reset form when closing
  useEffect(() => {
    if (!isOpen) {
      setRoleName("");
      setDescription("");
      setPermissions({});
      setSidebarItems([]);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const allSelected =
    Object.keys(permissions).length > 0 &&
    Object.values(permissions).every(Boolean);

  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    const updated = {};
    Object.keys(permissions).forEach((key) => {
      updated[key] = checked;
    });
    setPermissions(updated);
  };

  const handleChange = (item) => {
    setPermissions((prev) => ({
      ...prev,
      [item]: !prev[item],
    }));
  };

  const handleUpdate = async () => {
    const selectedPermissions = Object.keys(permissions).filter(
      (key) => permissions[key]
    );

    if (!roleName.trim()) {
      alert("Role name is required");
      return;
    }

    if (selectedPermissions.length === 0) {
      alert("Select at least one permission");
      return;
    }

    const payload = {
      roleName: roleName.trim(),
      description: description.trim(),
      permissions: selectedPermissions,
    };

    try {
      setLoading(true);

      const response=await UpdateRoleAPI(role?._id, payload);

      if(response?.data?.success){
        toast.success(response?.data?.message||"Role Updated Successfully!")
         onUpdated();  // refresh table
      onClose();    // close modal
      }
      else{
         toast.error(response?.data?.message||"Role Not Updated!")
      }


     
    } catch (err) {
      console.error("Role update failed", err);
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
  setRoleName("");
  setDescription("");

  const resetPermissions = {};
  sidebarItems.forEach((item) => {
    resetPermissions[item.name] = false;
  });

  setPermissions(resetPermissions);
};

if(loading){
  return <Loader/>
}

  return (
    <div className="add-role__backdrop">
      <div className="add-role__modal">
        <h3>Edit Role</h3>

        <div className="add-role__form-group">
          <label>Role Name</label>
          <input
            type="text"
            value={roleName}
            onChange={(e) => setRoleName(e.target.value)}
          />
        </div>

        <div className="add-role__form-group">
          <label>Description</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>

        <div className="add-role__permissions">
          <label>Permissions</label>

          <label className="add-role__checkbox select-all">
             <input
              type="checkbox"
              checked={allSelected}
              onChange={handleSelectAll}
            />
            <span>Select All</span>
           
          </label>

          <hr />

          <div className="add-role__permissions-grid">
            {sidebarItems.map((item) => (
              <label key={item._id} className="add-role__checkbox">
                <input
                  type="checkbox"
                  checked={permissions[item.name] || false}
                  onChange={() => handleChange(item.name)}
                />
                <span>{item.name}</span>
              </label>
            ))}
          </div>
        </div>

        <div className="add-role__actions">
          <button
            className="add-role__btn-cancel"
             onClick={() => {
              resetForm();
              onClose();
            }}
            disabled={loading}
          >
            Cancel
          </button>

          <button
            className="add-role__btn-save"
            onClick={handleUpdate}
            disabled={loading}
          >
            {loading ? "Updating..." : "Update"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditRoleModal;
